<div class="accept-offer-page">
  <!-- Top Brand Bar -->
  <div class="brand-bar">
    <span class="brand-name">FOXCLOUD</span>
  </div>

  <!-- Overlay for closing dropdowns -->
  <div class="dropdown-overlay" *ngIf="showConsolidationTypeDropdown || showDeliveryPreferenceDropdown || showShippingAddressDropdown || showShippingResponsabilityDropdown || showShippingCompanyDropdown || showShippingServiceTypeDropdown" (click)="closeDropdowns()"></div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="loading">
    <div class="loading-spinner"></div>
    <p>Loading offer...</p>
  </div>

  <!-- Error State -->
  <div class="error-container" *ngIf="error && !loading">
    <i class="material-icons error-icon">error_outline</i>
    <p>{{ error }}</p>
  </div>

  <!-- Already Accepted State -->
  <div class="already-accepted-container" *ngIf="alreadyAccepted && !loading && !error">
    <i class="material-icons success-icon">check_circle</i>
    <h2>Offer Already Accepted</h2>
    <p>This offer has already been accepted and converted to an Order Confirmation.</p>
    <div class="offer-info">
      <span class="offer-ref">{{ Offer?.ReferenceNumber }}</span>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-container" *ngIf="Offer && !loading && !error && !alreadyAccepted">
    <div class="content-container">

      <!-- Header Section - PDF Style -->
      <div class="header-section">
        <!-- White arch area with logo -->
        <div class="header-arch"></div>

        <div class="header-content">
          <!-- Left side: Logo -->
          <div class="header-logo-area">
            <img *ngIf="Offer?.Company?.LogoPath?.length > 0" class="company-logo" [src]="APIUrl + Offer.Company.LogoPath" />
          </div>

          <!-- Right side: Contact info & Company - all stacked vertically on right -->
          <div class="header-info-area">
            <div class="header-info-stack">
              <!-- Agent contact info -->
              <div class="contact-item" *ngIf="Offer?.AgentManager?.Phone">
                <i class="material-icons">phone</i>
                {{ Offer.AgentManager.Phone }}
              </div>
              <div class="contact-item" *ngIf="Offer?.AgentManager?.Email">
                <i class="material-icons">email</i>
                {{ Offer.AgentManager.Email }}
              </div>
              <!-- Company name & address -->
              <div class="company-name">{{ Offer?.Company?.Name }}</div>
              <div class="company-address" *ngIf="Offer?.Company?.Addresses?.length > 0">{{ Offer.Company.Addresses[0].City }}, {{ Offer.Company.Addresses[0].Country?.Name }}</div>
            </div>
          </div>
        </div>

      </div>

      <!-- Reference Numbers Row -->
      <div class="reference-section">
        <div class="reference-group-left">
          <div class="reference-item">
            <span class="reference-value">{{ Offer.ReferenceNumber }}</span>
            <span class="reference-label">{{ getTranslation('OurReference') }}</span>
          </div>
          <div class="reference-item" *ngIf="Offer.DebatorPO">
            <span class="reference-value debator-po">{{ Offer.DebatorPO }}</span>
            <span class="reference-label">{{ getTranslation('YourReference') }}</span>
          </div>
        </div>
        <div class="reference-group-right">
          <div class="reference-date-item" *ngIf="Offer.EventRegisterUI">
            <span class="reference-date-label">{{ getTranslation('Date') }}:</span>
            <span class="reference-date-value">{{ Offer.EventRegisterUI }}</span>
          </div>
          <div class="reference-date-item" *ngIf="Offer.ValidUntilUI">
            <span class="reference-date-label">{{ getTranslation('ValidUntil') }}:</span>
            <span class="reference-date-value valid-until-value">{{ Offer.ValidUntilUI }}</span>
          </div>
        </div>
      </div>

      <!-- Billing & Shipping Info Section -->
      <div class="info-section" *ngIf="Offer?.Cart?.Partner">
        <!-- Billing Information (Locked) -->
        <div class="info-box billing-box">
          <div class="info-box-header">
            <i class="material-icons">receipt</i>
            <span>Billing Information</span>
            <i class="material-icons lock-icon">lock</i>
          </div>
          <div class="info-box-content">
            <div class="info-row">
              <span class="info-label">Company:</span>
              <span class="info-value">{{ Offer.Cart.Partner?.Name }}</span>
            </div>
            <div class="info-row" *ngIf="Offer.Cart.Partner?.VAT">
              <span class="info-label">VAT:</span>
              <span class="info-value">{{ Offer.Cart.Partner?.VAT }}</span>
            </div>
            <div class="info-row" *ngIf="Offer.Cart.Partner?.COCRegNumber">
              <span class="info-label">Reg. No:</span>
              <span class="info-value">{{ Offer.Cart.Partner?.COCRegNumber }}</span>
            </div>
            <div class="info-row" *ngIf="Offer.Cart.Partner?.BillingAddress">
              <span class="info-label">Address:</span>
              <span class="info-value">
                {{ Offer.Cart.Partner?.BillingAddress?.AddressLine }}<span *ngIf="Offer.Cart.Partner?.BillingAddress?.City">, {{ Offer.Cart.Partner?.BillingAddress?.City }}</span><span *ngIf="Offer.Cart.Partner?.BillingAddress?.StateProvince">, {{ Offer.Cart.Partner?.BillingAddress?.StateProvince }}</span><span *ngIf="Offer.Cart.Partner?.BillingAddress?.ZipCode">, {{ Offer.Cart.Partner?.BillingAddress?.ZipCode }}</span><span *ngIf="Offer.Cart.Partner?.BillingAddress?.Country?.Name">, {{ Offer.Cart.Partner?.BillingAddress?.Country?.Name }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Shipping Information (Editable) -->
        <div class="info-box shipping-box">
          <div class="info-box-header">
            <i class="material-icons">local_shipping</i>
            <span>Shipping Address</span>
            <i class="material-icons edit-icon">edit</i>
          </div>
          <div class="info-box-content">
            <!-- Shipping Address Dropdown -->
            <div class="CustomDropdownContainer shipping-dropdown" *ngIf="PartnerShippingAddresses?.length > 0">
              <div class="CustomDropdownBar" (click)="onShippingAddressFocus()">
                <i class="material-icons dropdown-icon-left">location_on</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="selectedShippingAddress?.ContactName || 'Select address...'" />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showShippingAddressDropdown">
                <div class="CustomDropdownResult" *ngFor="let addr of PartnerShippingAddresses"
                     (click)="selectShippingAddress(addr)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedShippingAddress?.ID === addr.ID ? '#10b981' : '#9ca3af'">
                      {{ selectedShippingAddress?.ID === addr.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{ addr.ContactName || getShippingAddressDisplay(addr) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Editable Shipping Fields -->
            <div class="shipping-fields" *ngIf="selectedShippingAddress">
              <div class="shipping-field-row">
                <label>Contact:</label>
                <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.ContactName" (input)="checkShippingAddressChanged()" />
              </div>
              <div class="shipping-field-row">
                <label>Address:</label>
                <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.AddressLine" (input)="checkShippingAddressChanged()" />
              </div>
              <div class="shipping-field-row-group">
                <div class="shipping-field-row half">
                  <label>City:</label>
                  <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.City" (input)="checkShippingAddressChanged()" />
                </div>
                <div class="shipping-field-row half">
                  <label>Zip:</label>
                  <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.ZipCode" (input)="checkShippingAddressChanged()" />
                </div>
              </div>
              <div class="shipping-field-row">
                <label>State:</label>
                <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.StateProvince" (input)="checkShippingAddressChanged()" />
              </div>
              <div class="shipping-field-row">
                <label>Country:</label>
                <input type="text" class="shipping-input locked" readonly [value]="selectedShippingAddress?.Country?.Name" />
              </div>
              <div class="shipping-field-row-group">
                <div class="shipping-field-row half">
                  <label>Email:</label>
                  <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.Email" (input)="checkShippingAddressChanged()" />
                </div>
                <div class="shipping-field-row half">
                  <label>Phone:</label>
                  <input type="text" class="shipping-input" [(ngModel)]="selectedShippingAddress.Phone" (input)="checkShippingAddressChanged()" />
                </div>
              </div>

              <!-- Save Address Dropdown - shown when address has changed -->
              <div class="save-address-container" *ngIf="shippingAddressChanged">
                <div class="save-address-dropdown">
                  <div class="save-address-bar" (click)="toggleSaveAddressDropdown()">
                    <i class="material-icons">{{ selectedSaveOption ? (selectedSaveOption === 'new' ? 'add_location' : 'edit_location') : 'save' }}</i>
                    <span>{{ getSaveOptionText() }}</span>
                    <i class="material-icons dropdown-arrow">{{ showSaveAddressDropdown ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
                  </div>
                  <div class="save-address-options" *ngIf="showSaveAddressDropdown">
                    <div class="save-address-option" (click)="selectSaveOption('new')" [class.selected]="selectedSaveOption === 'new'">
                      <i class="material-icons">add_location</i>
                      <span>{{ getTranslation('AddAsNewAddress') }}</span>
                    </div>
                    <div class="save-address-option" (click)="selectSaveOption('update')" [class.selected]="selectedSaveOption === 'update'">
                      <i class="material-icons">edit_location</i>
                      <span>{{ getTranslation('UpdateExistingAddress') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Controls Section -->
      <div class="controls-section">
        <div class="controls-row">
          <!-- Consolidation Type Dropdown -->
          <div class="control-group" *ngIf="MasterData?.OrderConsolidationTypes?.length > 0">
            <div class="CustomDropdownContainer">
              <div class="CustomDropdownBar" (click)="onConsolidationTypeFocus()">
                <i class="material-icons dropdown-icon-left">inventory_2</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="selectedConsolidationType?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showConsolidationTypeDropdown">
                <div class="CustomDropdownResult" *ngFor="let type of MasterData.OrderConsolidationTypes"
                     (click)="selectConsolidationType(type)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedConsolidationType?.ID === type.ID ? '#10b981' : '#9ca3af'">
                      {{ selectedConsolidationType?.ID === type.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{ type.Name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Delivery Preference Dropdown -->
          <div class="control-group" *ngIf="MasterData?.OrderDeliveryPreferences?.length > 0">
            <div class="CustomDropdownContainer">
              <div class="CustomDropdownBar"
                   [class.locked-dropdown]="deliveryPreferenceBlocked"
                   (click)="!deliveryPreferenceBlocked && onDeliveryPreferenceFocus()">
                <i class="material-icons dropdown-icon-left">local_shipping</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="selectedDeliveryPreference?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon" [class.locked-icon]="deliveryPreferenceBlocked">
                  {{ deliveryPreferenceBlocked ? 'lock' : 'arrow_drop_down' }}
                </i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showDeliveryPreferenceDropdown && !deliveryPreferenceBlocked">
                <div class="CustomDropdownResult" *ngFor="let pref of MasterData.OrderDeliveryPreferences"
                     (click)="selectDeliveryPreference(pref)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedDeliveryPreference?.ID === pref.ID ? '#10b981' : '#9ca3af'">
                      {{ selectedDeliveryPreference?.ID === pref.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{ pref.Name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Blocked for change disclaimer -->
            <div class="delivery-preference-disclaimer" *ngIf="deliveryPreferenceBlocked">
              <i class="material-icons">info_outline</i>
              <span>{{ getTranslation('DeliveryPreferenceBlockedDescription') }}</span>
            </div>
          </div>
        </div>

        <!-- Shipping Options Row -->
        <div class="controls-row" *ngIf="MasterData?.ShippingResponsabilities?.length > 0 || ShippingCompanies?.length > 0 || MasterData?.ShippingServiceTypes?.length > 0">
          <!-- Shipping Responsability - Locked when LockShippingSettings is true -->
          <div class="control-group" *ngIf="selectedShippingResponsability">
            <div class="CustomDropdownContainer">
              <div class="CustomDropdownBar"
                   [class.locked-dropdown]="Offer?.Cart?.LockShippingSettings"
                   (click)="!Offer?.Cart?.LockShippingSettings && onShippingResponsabilityFocus()">
                <i class="material-icons dropdown-icon-left">assignment_ind</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="selectedShippingResponsability?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon" [class.locked-icon]="Offer?.Cart?.LockShippingSettings">
                  {{ Offer?.Cart?.LockShippingSettings ? 'lock' : 'arrow_drop_down' }}
                </i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityDropdown && !Offer?.Cart?.LockShippingSettings">
                <div class="CustomDropdownResult" *ngFor="let item of MasterData.ShippingResponsabilities"
                     (click)="selectShippingResponsability(item)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedShippingResponsability?.ID === item.ID ? '#10b981' : '#9ca3af'">
                      {{ selectedShippingResponsability?.ID === item.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{ item.Name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Shipping Company Dropdown (hidden when EXW selected, locked when LockShippingSettings) -->
          <div class="control-group" *ngIf="ShippingCompanies?.length > 0 && selectedShippingResponsability?.ID !== 0">
            <div class="CustomDropdownContainer">
              <div class="CustomDropdownBar"
                   [class.locked-dropdown]="Offer?.Cart?.LockShippingSettings"
                   (click)="!Offer?.Cart?.LockShippingSettings && onShippingCompanyFocus()">
                <i class="material-icons dropdown-icon-left">business</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="selectedShippingCompany?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon" [class.locked-icon]="Offer?.Cart?.LockShippingSettings">
                  {{ Offer?.Cart?.LockShippingSettings ? 'lock' : 'arrow_drop_down' }}
                </i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showShippingCompanyDropdown && !Offer?.Cart?.LockShippingSettings">
                <div class="CustomDropdownResult" *ngFor="let item of ShippingCompanies"
                     (click)="selectShippingCompany(item)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedShippingCompany?.ID === item.ID ? '#10b981' : '#9ca3af'">
                      {{ selectedShippingCompany?.ID === item.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <img *ngIf="item.Logo" [src]="item.Logo" class="shipping-company-logo" />
                    <span class="CustomDropdownResultText">{{ item.Name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Shipping Service Type Dropdown (hidden when EXW selected, locked when LockShippingSettings) -->
          <div class="control-group" *ngIf="MasterData?.ShippingServiceTypes?.length > 0 && selectedShippingResponsability?.ID !== 0">
            <div class="CustomDropdownContainer">
              <div class="CustomDropdownBar"
                   [class.locked-dropdown]="Offer?.Cart?.LockShippingSettings"
                   (click)="!Offer?.Cart?.LockShippingSettings && onShippingServiceTypeFocus()">
                <i class="material-icons dropdown-icon-left">speed</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="selectedShippingServiceType?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon" [class.locked-icon]="Offer?.Cart?.LockShippingSettings">
                  {{ Offer?.Cart?.LockShippingSettings ? 'lock' : 'arrow_drop_down' }}
                </i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeDropdown && !Offer?.Cart?.LockShippingSettings">
                <div class="CustomDropdownResult" *ngFor="let item of MasterData.ShippingServiceTypes"
                     (click)="selectShippingServiceType(item)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="selectedShippingServiceType?.ID === item.ID ? '#10b981' : '#9ca3af'">
                      {{ selectedShippingServiceType?.ID === item.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{ item.Name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Responsability Description -->
        <div class="ResponsabilityDescriptionContainer" *ngIf="selectedShippingResponsability?.Description">
          <span class="ResponsabilityDescriptionInfo">{{ selectedShippingResponsability.Description }}</span>
        </div>

        <!-- ✅ Products Insurance Section (shown when DAP, DDP, or FCA selected) -->
        <!-- If DB HasInsurance was false, user can freely toggle on any responsability -->
        <!-- If DB HasInsurance was true AND responsability requires it, toggle is disabled and forced ON -->
        <div class="InsuranceSectionWrapper" id="insurance-section" *ngIf="selectedShippingResponsability?.RequiresInsurance != null">
          <div class="InsuranceSectionTitle">
            <i class="material-icons">verified_user</i>
            <span>{{ getTranslation('Insurance') }}</span>
          </div>
          <div class="InsuranceContainer">
            <mat-slide-toggle
              [disabled]="originalDBHasInsurance === true && selectedShippingResponsability?.RequiresInsurance === true"
              matTooltip="{{ 'RequestProductsInsuranceDescription' | translate}}"
              matTooltipClass='neutral-tool-tip'
              class="InsuranceToggleSetting"
              [(ngModel)]="this.Offer.Cart.HasInsurance">
            </mat-slide-toggle>
            <span class="InsuranceContainerInfo" [class.insurance-active]="Offer?.Cart?.HasInsurance === true">{{ 'RequestProductsInsuranceDescription2' | translate}}</span>
          </div>

          <!-- Insurance Value Row (shown when insurance toggle is ON) -->
          <div class="InsuranceValueContainer" *ngIf="Offer?.Cart?.HasInsurance === true">
            <span class="InsuranceValueInfo">{{ getTranslation('InsuranceValue') }}: {{ getInsuranceValue() }} {{ Offer?.Cart?.Currency?.Symbol || '' }}</span>
          </div>
        </div>
      </div>

      <!-- Cart Items Table -->
      <div class="cart-section" *ngIf="Offer?.Cart?.Items?.length > 0">
        <div class="modern-table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th style="width: 45px;" class="text-center">#</th>
                <th>{{ getTranslation('Product') }}</th>
                <th style="width: 60px; text-align: center;">{{ getTranslation('Quantity') }}</th>
                <th style="width: 105px; text-align: right;" *ngIf="showListPriceDiscount">{{ getTranslation('ListPrice') }}</th>
                <th style="width: 75px; text-align: center;" *ngIf="showListPriceDiscount">{{ getTranslation('Discount') }}</th>
                <th style="width: 105px; text-align: right;">{{ getTranslation('UnitPrice') }}</th>
                <th style="width: 105px; text-align: right;">{{ getTranslation('Total') }} ({{ Offer.Cart.Currency?.Symbol }})</th>
                <th style="width: 110px; text-align: center;">{{ getTranslation('StandardDelivery') }}</th>
                <th style="width: 40px; text-align: center;"><i class="material-icons" style="font-size: 16px; color: #8e8e93;">description</i></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Offer.Cart.Items; let i = index">
                <td class="text-center" style="color: #aeaeb2; font-weight: 600; font-size: 10px;">{{ i + 1 }}</td>
                <td>
                  <div>
                    <strong style="font-size: 11px;">{{ item.Product?.Brand?.Name }}</strong>
                    <span style="color: #8e8e93; font-size: 10px; margin-left: 4px;">[{{ item.Product?.PartNumber }}]</span>
                  </div>
                  <div style="color: #1c1c1e; font-size: 11px; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.Product?.Name }}</div>
                </td>
                <td class="text-center" style="font-weight: 600;">{{ item.Quantity }}</td>
                <td class="text-right" *ngIf="showListPriceDiscount" style="color: #8e8e93;">{{ item.Product?.Stats?.StandardListPrice?.UIUnitPrice || '-' }}</td>
                <td class="text-center" *ngIf="showListPriceDiscount" style="color: #8e8e93;">{{ getDiscountPercent(item) }}</td>
                <td class="text-right" style="font-weight: 500;">{{ item.SelectedOffer?.SellingPrice || item.SelectedOffer?.SellPrice?.UIUnitPrice || item.Price?.UIUnitPrice || '-' }}</td>
                <td class="text-right" style="font-weight: 600;">{{ getItemTotal(item) }}</td>
                <td class="text-center">
                  <span class="lead-time-badge" *ngIf="item.SelectedOffer?.LeadTime?.Type?.Name">
                    {{ item.SelectedOffer?.LeadTime?.Units }} {{ item.SelectedOffer?.LeadTime?.Type?.Name }}
                  </span>
                  <span *ngIf="!item.SelectedOffer?.LeadTime?.Type?.Name" style="color: #c7c7cc;">-</span>
                </td>
                <td class="text-center">
                  <button class="datasheet-button" *ngIf="item.Product?.Stats?.DatasheetLink"
                          (click)="openDatasheet(item.Product.Stats.DatasheetLink)"
                          title="Open datasheet">
                    <i class="material-icons">description</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Totals Section -->
      <div class="totals-section" *ngIf="Offer?.Cart?.Total">
        <!-- Subtotal (from OriginalTotal - before any project discount) -->
        <div class="total-row subtotal-row">
          <span class="total-label">{{ getTranslation('Subtotal') }}:</span>
          <span class="total-value subtotal-value">{{ Offer.Cart.OriginalTotal?.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ Offer.Cart.Currency?.Symbol }}</span>
        </div>

        <!-- Project Discount Row (only shown if discount exists) -->
        <div class="total-row discount-row" *ngIf="Offer.Cart.Total?.Discount?.Value > 0">
          <span class="total-label discount-label">{{ getTranslation('ProjectDiscount') }} ({{ Offer.Cart.Total.Discount.Value }}%):</span>
          <span class="total-value discount-value">- {{ getProjectDiscountAmount() }} {{ Offer.Cart.Currency?.Symbol }}</span>
        </div>

        <!-- Subtotal After Discount (only shown if discount exists) -->
        <div class="total-row subtotal-after-discount-row" *ngIf="Offer.Cart.Total?.Discount?.Value > 0">
          <span class="total-label">{{ getTranslation('SubtotalAfterDiscount') }}:</span>
          <span class="total-value">{{ Offer.Cart.Total.UITotalQtyPriceNOVAT?.Integer }}{{ Offer.Cart.Total.UITotalQtyPriceNOVAT?.Decimals }} {{ Offer.Cart.Currency?.Symbol }}</span>
        </div>

        <!-- Shipping Cost Row -->
        <div class="total-row shipping-row">
          <span class="total-label">{{ getTranslation('ShippingCost') }}:</span>
          <span class="total-value shipping-value">{{ Offer.Cart.ShippingCost?.UIUnitPrice != null ? (Offer.Cart.ShippingCost.UIUnitPrice | number:'1.2-2') : '--,--' }} {{ Offer.Cart.Currency?.Symbol }}</span>
        </div>

        <!-- Final Total (Subtotal + Shipping) -->
        <div class="total-row absolute-total-row" [class.no-border]="Offer?.Cart?.HasInsurance === true">
          <span class="total-label">{{ getTranslation('GrandTotal') }}:</span>
          <span class="total-value absolute-total-value">{{ getAbsoluteTotal() }} {{ Offer.Cart.Currency?.Symbol }}</span>
        </div>

        <!-- Insurance Row (shown when insurance toggle is ON) -->
        <div class="total-row insurance-row clickable" *ngIf="Offer?.Cart?.HasInsurance === true" (click)="scrollToInsuranceSection()">
          <span class="total-label insurance-label">{{ getTranslation('InsuranceValue') }}:</span>
          <span class="total-value insurance-value">+ {{ getInsuranceValue() }} {{ Offer.Cart.Currency?.Symbol }}</span>
          <i class="material-icons insurance-link-icon">arrow_upward</i>
        </div>
      </div>

      <!-- Payment Terms Section -->
      <div class="payment-terms-section" *ngIf="Offer?.Cart?.PaymentTerm?.Name">
        <div class="payment-terms-row">
          <span class="payment-terms-label">{{ getTranslation('PaymentTerms') }}:</span>
          <span class="payment-terms-value">{{ Offer.Cart.PaymentTerm.Name }}</span>
        </div>
      </div>

      <!-- Accept Button Section -->
      <div class="accept-section" *ngIf="!acceptSuccess">
        <!-- PO Input above Accept Button -->
        <div class="po-input-section">
          <div class="CustomDropdownContainer po-container">
            <div class="CustomDropdownBar po-input-bar" style="cursor: text;">
              <i class="material-icons dropdown-icon-left po-icon">description</i>
              <input type="text" class="CustomDropdownInput" style="cursor: text;"
                     [value]="debatorPO"
                     (input)="onDebatorPOChange($any($event.target).value)"
                     placeholder="Enter your PO number" />
            </div>
          </div>
        </div>

        <!-- Pricing Disclaimer -->
        <div class="pricing-disclaimer">
          <i class="material-icons">info_outline</i>
          <span>{{ getTranslation('PricingDisclaimer') }}</span>
        </div>

        <!-- Expired Offer Disclaimer -->
        <div class="expired-disclaimer" *ngIf="Offer?.OfferValidityStatus === -1" (click)="scrollToContactSection()">
          <i class="material-icons">warning</i>
          <span>{{ getTranslation('OfferExpiredDisclaimer') }}</span>
          <i class="material-icons arrow-icon">arrow_downward</i>
        </div>

        <div class="accept-error" *ngIf="acceptError">
          <i class="material-icons">error_outline</i>
          <span>{{ acceptError }}</span>
        </div>
        <button class="accept-button" (click)="onAcceptClick()" [disabled]="accepting || !allItemsHavePrice || Offer?.OfferValidityStatus === -1" [class.disabled-button]="!allItemsHavePrice || Offer?.OfferValidityStatus === -1">
          <i class="material-icons" *ngIf="!accepting">check_circle</i>
          <span *ngIf="!accepting">Accept Offer</span>
          <span *ngIf="accepting" class="accepting-text">
            <div class="button-spinner"></div>
            Processing...
          </span>
        </button>
        <!-- Disclaimer when not all items have price -->
        <div class="accept-disabled-disclaimer" *ngIf="!allItemsHavePrice">
          <i class="material-icons">info_outline</i>
          <span>{{ getTranslation('AcceptOfferDisabledDescription') }}</span>
        </div>
      </div>

      <!-- Confirm PO Missing Popup -->
      <div class="popup-overlay" *ngIf="showPOConfirmPopup" (click)="closePOConfirmPopup()">
        <div class="popup-container" (click)="$event.stopPropagation()">
          <div class="popup-header">
            <i class="material-icons popup-warning-icon">warning</i>
            <span class="popup-title">Missing Reference Number</span>
          </div>
          <div class="popup-body">
            <p>You haven't entered your reference (PO) number. Are you sure you want to continue without it?</p>
          </div>
          <div class="popup-actions">
            <button class="popup-btn popup-btn-cancel" (click)="closePOConfirmPopup()">
              <i class="material-icons">edit</i>
              Go Back & Enter PO
            </button>
            <button class="popup-btn popup-btn-confirm" (click)="confirmAcceptWithoutPO()">
              <i class="material-icons">check</i>
              Continue Anyway
            </button>
          </div>
        </div>
      </div>

      <!-- Success State -->
      <div class="success-section" *ngIf="acceptSuccess">
        <div class="success-content">
          <i class="material-icons success-icon">check_circle</i>
          <h2 class="success-title">Offer Accepted!</h2>
          <p class="success-message">Your order confirmation has been created successfully.</p>
          <div class="success-reference" *ngIf="createdOrderConfirmation?.ReferenceNumber">
            <span class="ref-label">Order Reference:</span>
            <span class="ref-value">{{ createdOrderConfirmation.ReferenceNumber }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Footer Info Container -->
  <div class="footer-info-container" *ngIf="Offer && !loading">
    <!-- Legal & Banking Info Section -->
    <div class="footer-section legal-section">
      <div class="footer-section-title">
        <i class="material-icons">account_balance</i>
        {{ getTranslation('LegalBankingInfo') }}
      </div>
      <div class="footer-section-body">
        <div class="company-info" *ngIf="Offer?.Company">
          <div class="company-name">{{ Offer.Company?.Name }}</div>
          <div class="company-detail" *ngIf="Offer.Company?.VATNumber">
            <span class="detail-label">{{ getTranslation('VAT') }}:</span>
            <span class="detail-value">{{ Offer.Company?.VATNumber }}</span>
          </div>
          <div class="company-detail" *ngIf="Offer.Company?.COCRegisterNr">
            <span class="detail-label">{{ getTranslation('RegCom') }}:</span>
            <span class="detail-value">{{ Offer.Company?.COCRegisterNr }}</span>
          </div>
          <div class="company-detail" *ngIf="Offer.Company?.Addresses?.length">
            <span class="detail-label">{{ getTranslation('Address') }}:</span>
            <span class="detail-value">
              {{ Offer.Company.Addresses[0]?.AddressLine }},
              {{ Offer.Company.Addresses[0]?.City }} {{ Offer.Company.Addresses[0]?.ZipCode }},
              {{ Offer.Company.Addresses[0]?.Country?.Name }}
            </span>
          </div>
          <div class="company-detail bank-info" *ngIf="Offer.Company?.Banks?.length && Offer.Company.Banks[0]?.BankAccounts?.length">
            <span class="detail-label">{{ getTranslation('BankAccount') }} ({{ Offer.Company.Banks[0].BankAccounts[0]?.Currency?.Name }}):</span>
            <span class="detail-value">{{ Offer.Company.Banks[0].BankAccounts[0]?.AccountNumber }}</span>
          </div>
          <div class="company-detail" *ngIf="Offer.Company?.Banks?.length && Offer.Company.Banks[0]?.Swift">
            <span class="detail-label">SWIFT:</span>
            <span class="detail-value">{{ Offer.Company.Banks[0].Swift }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Our Team Section -->
    <div class="footer-section contact-section" id="contact-section">
      <div class="footer-section-title">
        <i class="material-icons">support_agent</i>
        {{ getTranslation('ContactOurTeam') }}
      </div>
      <div class="footer-section-body">
        <div class="agents-grid">
          <div class="contact-agent" *ngFor="let agent of Offer?.Company?.Agents">
            <div class="agent-name">{{ agent?.Name }}</div>
            <div class="agent-function" *ngIf="agent?.Function">{{ agent?.Function }}</div>
            <div class="agent-detail" *ngIf="agent?.Email">
              <i class="material-icons">email</i>
              <a [href]="'mailto:' + agent?.Email">{{ agent?.Email }}</a>
            </div>
            <div class="agent-detail" *ngIf="agent?.Phone">
              <i class="material-icons">phone</i>
              <a [href]="'tel:' + agent?.Phone">{{ agent?.Phone }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
